import { Image, ModalTitle } from '@cian/ui-kit';
import * as React from 'react';
import clsx from 'clsx';

import type { IAiSummaryNewbuilding } from '../../types';

import * as styles from './styles.css';

export interface IContentHeaderProps {
  activeNewbuildingId: number;
  items: IAiSummaryNewbuilding[];
  title: string;
  onSelectNewbuilding: (id: number) => void;
}

export const ContentHeader = ({
  activeNewbuildingId,
  items,
  title,
  onSelectNewbuilding,
}: IContentHeaderProps): React.JSX.Element => {
  return (
    <div className={styles['container']}>
      <ModalTitle>{title}</ModalTitle>
      <div className={styles['tabs']}>
        {items.map(item => {
          const isActive = activeNewbuildingId === item.id;

          return (
            <div
              className={clsx(styles['image-wrapper'], isActive && styles['active-boarder'])}
              data-testid={`ai-summary-tab-${item.id}`}
              key={item.id}
              onClick={() => onSelectNewbuilding(item.id)}
            >
              <Image borderRadius="8px" height={48} src={item.imageUrl} width={48} />
            </div>
          );
        })}
      </div>
    </div>
  );
};
